var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"head"},[_c('el-breadcrumb',{staticStyle:{"margin":"auto auto auto 10px"},attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("人员在岗在位")])],1)],1),_c('div',{staticClass:"content"},[_c('div',[_c('iframe',{attrs:{"name":"I1","src":_vm.src,"height":"800px","width":"100%"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }